import { render, staticRenderFns } from "./linkClick.vue?vue&type=template&id=1053cb0a"
import script from "./linkClick.vue?vue&type=script&lang=js"
export * from "./linkClick.vue?vue&type=script&lang=js"
import style0 from "./linkClick.vue?vue&type=style&index=0&id=1053cb0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports